import PublicLayout from '@/components/public/PublicLayout';

export default function NormativasParquePage() {
    return (
        <PublicLayout>
            <section className="relative overflow-hidden bg-gradient-sky text-white py-14">
                <div className="absolute -top-16 -left-16 w-72 h-72 rounded-full bg-[hsl(var(--kche-yellow))]/30 blur-3xl" />
                <div className="relative mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
                    <p className="text-sm font-bold font-display text-[hsl(var(--kche-yellow))] uppercase tracking-wider">Legal</p>
                    <h1 className="mt-1 text-4xl sm:text-5xl font-display font-bold">Normativas del parque</h1>
                </div>
            </section>
            <section className="bg-background py-14">
                <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
                    <div className="rounded-3xl bg-white border border-border shadow-soft p-6 sm:p-8 prose prose-sm sm:prose-base max-w-none">
                        <p className="text-muted-foreground"><strong>TODO:</strong> el reglamento definitivo del parque está pendiente de confirmación por el cliente.</p>
                        <ul>
                            <li>Sigue las indicaciones del personal en cada atracción.</li>
                            <li>Los menores deben estar acompañados por un adulto responsable.</li>
                            <li>Cuídate y cuida a los demás; respeta los turnos y filas.</li>
                            <li>Algunas atracciones pueden tener restricciones de altura o salud.</li>
                            <li>K\'che se reserva el derecho de admisión.</li>
                        </ul>
                        <p className="text-xs text-muted-foreground italic">Las reglas finales y restricciones específicas serán confirmadas por el cliente.</p>
                    </div>
                </div>
            </section>
        </PublicLayout>
    );
}
